import * as React from 'react';

var UitkRadioButtonGroupContext = React.createContext(null);

export { UitkRadioButtonGroupContext };
